// ─── Карта программы: все экраны одним списком ───────────────────────────────
//
// Раньше такого списка не было нигде. Куда можно попасть, знало боковое меню
// (components/Layout.js), а что лежит внутри страницы — знала сама страница, и
// каждая по-своему. Человек, который не помнил дорогу наизусть, найти экран не
// мог: поиск по Ctrl+K искал заказы, паллеты и клиентов, но не умел ответить на
// вопрос «где тут пользователи».
//
// Здесь — один список на всю программу. По нему работает поиск: набрал
// «парол» — получил «Администрирование › Пользователи» и попал туда одним
// нажатием, не зная, что это лежит за дверью «Настройка».
//
// Поле find — то, как об экране спрашивают вслух, а не как он подписан. Люди
// ищут «юзер», «норма», «температура», «1С» — подписи таких слов не содержат.
//
// ВАЖНО. Пока это ВТОРАЯ копия названий: страницы «Технолог» и «Продажи и
// заказы» всё ещё держат свои списки разделов внутри себя. Их не трогаем — на
// них прямо сейчас работает Шымкент. Остальные страницы уже берут разделы
// отсюда, и у них копия одна. Когда до технолога и менеджера дойдёт очередь —
// они переедут сюда же, и второй копии не останется.

// s   — раздел внутри страницы (открывается через ?s=ключ)
// at  — как называется дверь, за которой экран лежит (для строки поиска)
const S = [
  // ── Рабочие места ролей ────────────────────────────────────────────────────
  { ic: '📊', label: 'Дашборд директора', to: '/director',
    roles: ['director', 'admin'], find: 'обзор сводка главный руководитель' },
  { ic: '🛒', label: 'Продажи и заказы', to: '/manager',
    roles: ['manager', 'admin'], find: 'менеджер сбыт клиент' },
  { ic: '⚙️', label: 'Очередь производства', to: '/technolog',
    roles: ['technolog', 'admin'], find: 'технолог цех план' },
  { ic: '🗓', label: 'Заявка на производство', to: '/production-requests',
    roles: ['technolog', 'admin'], find: 'сменный план бланк печать смена' },
  { ic: '🔬', label: 'Качество: разбор листов', to: '/quality',
    roles: ['quality', 'technolog', 'director', 'admin'],
    find: 'брак сорт причина анализ выводы срезы' },
  { ic: '🖥', label: 'Терминал оператора', to: '/terminal',
    roles: ['operator', 'admin'], find: 'пресс моноблок станок счётчик' },
  { ic: '📦', label: 'Склад ГП', to: '/warehouse',
    roles: ['sklad_gp', 'admin'], find: 'кладовщик приёмка остаток' },
  { ic: '🧾', label: 'Бухгалтерия', to: '/buhgalter',
    roles: ['buhgalter', 'admin'], find: 'бухгалтер 1с обмен' },
  { ic: '🔧', label: 'Администрирование', to: '/admin',
    roles: ['admin'], find: 'админ настройка' },
  { ic: '🏭', label: 'Что делается сейчас', to: '/board',
    roles: ['manager', 'technolog', 'quality', 'operator', 'sklad_gp', 'controller',
            'director', 'admin', 'buhgalter'],
    find: 'щит табло текущее прессы онлайн работа на прессах распределено план' },
  { ic: '🏷', label: 'Терминал пересортицы', to: '/sheet-terminal',
    roles: ['sklad_gp', 'controller', 'admin'],
    find: 'контролёр сорт бирка сканер планшет' },

  // ── Директор: разделы дашборда ─────────────────────────────────────────────
  { ic: '📋', label: 'Заказы', to: '/director', s: 'orders',
    at: 'Дашборд директора', roles: ['director', 'admin'],
    find: 'сроки просрочка портфель' },
  { ic: '🏭', label: 'Выпуск', to: '/director', s: 'output',
    at: 'Дашборд директора', roles: ['director', 'admin'],
    find: 'сколько сделали листов смена' },
  { ic: '⚙️', label: 'Загрузка прессов', to: '/director', s: 'presses',
    at: 'Дашборд директора', roles: ['director', 'admin'],
    find: 'oee оее эффективность простой доступность' },
  { ic: '🏷', label: 'Кто менял сорта', to: '/director', s: 'regrade',
    at: 'Дашборд директора', roles: ['director', 'admin'],
    find: 'пересортица правка сорта кто' },
  { ic: '📉', label: 'Брак по сортам', to: '/director', s: 'defects',
    at: 'Дашборд директора', roles: ['director', 'admin'],
    find: 'сорта второй брак доля' },
  { ic: '🌡', label: 'Режим и брак', to: '/director', s: 'mode',
    at: 'Дашборд директора', roles: ['director', 'admin'],
    find: 'температура давление время связь' },
  { ic: '📈', label: 'Прогноз', to: '/director', s: 'forecast',
    at: 'Дашборд директора', roles: ['director', 'admin'],
    find: 'план вперёд ожидание' },
  { ic: '⏱', label: 'Простои прессов', to: '/director', s: 'time',
    at: 'Дашборд директора', roles: ['director', 'admin'],
    find: 'время остановки переналадка поломка' },

  // ── Склад: разделы ─────────────────────────────────────────────────────────
  { ic: '🏭', label: 'Приёмка из цеха', to: '/warehouse', s: 'acceptance',
    at: 'Склад ГП', roles: ['sklad_gp', 'admin'],
    find: 'принять смену пресс сдал листы' },
  { ic: '🏷', label: 'Изменить сорт', to: '/warehouse', s: 'regrade',
    at: 'Склад ГП', roles: ['sklad_gp', 'admin'],
    find: 'пересортица второй сорт брак перевести' },
  { ic: '🚚', label: 'Выдать клиенту', to: '/warehouse', s: 'ship',
    at: 'Склад ГП', roles: ['sklad_gp', 'admin'],
    find: 'отгрузка выдача машина распоряжение' },
  { ic: '⚠️', label: 'Брак ДСП', to: '/warehouse', s: 'dspdefect',
    at: 'Склад ГП', roles: ['sklad_gp', 'admin'],
    find: 'битые плиты списать' },
  { ic: '📦', label: 'Остатки', to: '/warehouse', s: 'stock',
    at: 'Склад ГП', roles: ['sklad_gp', 'admin'],
    find: 'сырьё плёнка дсп сколько лежит готовая продукция по складам' },

  // ── Бухгалтерия: разделы ───────────────────────────────────────────────────
  { ic: '⇆', label: 'Обмен с 1С', to: '/buhgalter', s: 'exchange',
    at: 'Бухгалтерия', roles: ['buhgalter', 'admin'],
    find: 'документы очередь ошибки выгрузка' },
  { ic: '🧾', label: 'Рецепты', to: '/buhgalter', s: 'recipes',
    at: 'Бухгалтерия', roles: ['buhgalter', 'admin'],
    find: 'состав нормы расхода из чего' },
  { ic: '🔁', label: 'Замены', to: '/buhgalter', s: 'subs',
    at: 'Бухгалтерия', roles: ['buhgalter', 'admin'],
    find: 'аналоги одинаковые плиты группа' },
  { ic: '📦', label: 'Остатки', to: '/buhgalter', s: 'balances',
    at: 'Бухгалтерия', roles: ['buhgalter', 'admin'],
    find: 'минус сверка склад количество' },

  // ── Администрирование: разделы ─────────────────────────────────────────────
  { ic: '📥', label: 'Разбор с прессов', to: '/admin', s: 'rejects',
    at: 'Администрирование', roles: ['admin'],
    find: 'непринятые смены моноблок ошибка' },
  { ic: '📊', label: 'Статистика', to: '/admin', s: 'stats',
    at: 'Администрирование', roles: ['admin'], find: 'цифры состояние завода' },
  { ic: '🔧', label: 'Общие правила', to: '/admin', s: 'general',
    at: 'Администрирование', roles: ['admin'],
    find: 'настройки системы заказы без остатка порог простоя' },
  { ic: '👥', label: 'Пользователи', to: '/admin', s: 'users',
    at: 'Администрирование', roles: ['admin'],
    find: 'юзер логин пароль роль доступ сотрудник завести' },
  { ic: '🧾', label: 'Рецепты', to: '/admin', s: 'recipes',
    at: 'Администрирование', roles: ['admin'],
    find: 'состав из чего лист плёнка клей' },
  { ic: '⚙️', label: 'Норма выработки прессов', to: '/admin', s: 'norms',
    at: 'Администрирование', roles: ['admin'],
    find: 'листов в час норма пресс производительность' },
  { ic: '⏸', label: 'Причины остановки', to: '/admin', s: 'stops',
    at: 'Администрирование', roles: ['admin'],
    find: 'простой переналадка поломка список оператор выбирает' },
  { ic: '🏷', label: 'Сорта и причины брака', to: '/admin', s: 'quality',
    at: 'Администрирование', roles: ['admin'],
    find: 'сорт брак список причина добавить' },
  { ic: '🏬', label: 'Склады', to: '/admin', s: 'wh',
    at: 'Администрирование', roles: ['admin'],
    find: 'какой склад за что отвечает категория' },
  { ic: '🔌', label: 'Терминалы у прессов', to: '/admin', s: 'devices',
    at: 'Администрирование', roles: ['admin'],
    find: 'моноблок ключ станок компьютер' },
  { ic: '🗑', label: 'Пометка на удаление', to: '/admin', s: 'trash',
    at: 'Администрирование', roles: ['admin'], find: 'удалить корзина' },
  { ic: '🧪', label: 'Тестовые данные', to: '/admin', s: 'testdata',
    at: 'Администрирование', roles: ['admin'], find: 'демо проверка заполнить' },

  // ── Качество: разделы ──────────────────────────────────────────────────────
  { ic: '💡', label: 'Выводы', to: '/quality', s: 'insights',
    at: 'Качество', roles: ['quality', 'technolog', 'director', 'admin'],
    find: 'на что смотреть подсказка' },
  { ic: '▦', label: 'Срезы', to: '/quality', s: 'slices',
    at: 'Качество', roles: ['quality', 'technolog', 'director', 'admin'],
    find: 'где хуже разрез пресс смена декор' },
  { ic: '▤', label: 'Реестр листов', to: '/quality', s: 'sheets',
    at: 'Качество', roles: ['quality', 'technolog', 'director', 'admin'],
    find: 'таблица бирка каждый лист' },

  // ── Технолог: разделы (копия — до его очереди на переделку) ────────────────
  { ic: '✅', label: 'Что запустить в работу', to: '/technolog', s: 'approval',
    at: 'Очередь производства', roles: ['technolog', 'admin'],
    find: 'согласование заказ раздать прессам' },
  { ic: '📦', label: 'Разрешение на отгрузку', to: '/technolog', s: 'stockOrders',
    at: 'Очередь производства', roles: ['technolog', 'admin'],
    find: 'заказ со склада разрешить без пресса' },
  { ic: '🚚', label: 'Выписать отгрузку', to: '/technolog', s: 'shipnotes',
    at: 'Очередь производства', roles: ['technolog', 'admin'],
    find: 'распоряжение складу что выдать' },
  { ic: '📋', label: 'Очередь производства', to: '/technolog', s: 'queue',
    at: 'Очередь производства', roles: ['technolog', 'admin'],
    find: 'что на прессах задания' },
  { ic: '🌡', label: 'Эталонные режимы', to: '/technolog', s: 'etalon',
    at: 'Очередь производства', roles: ['technolog', 'admin'],
    find: 'температура время давление как прессовать' },
  { ic: '🧾', label: 'Рецепты', to: '/technolog', s: 'recipes',
    at: 'Очередь производства › Справочники', roles: ['technolog', 'admin'],
    find: 'состав из чего лист плёнка клей' },
  { ic: '🔁', label: 'Замены', to: '/technolog', s: 'substitutes',
    at: 'Очередь производства › Справочники', roles: ['technolog', 'admin'],
    find: 'аналоги одинаковые плиты группа' },
  { ic: '⚙️', label: 'Состояние прессов', to: '/technolog', s: 'presses',
    at: 'Очередь производства › Справочники', roles: ['technolog', 'admin'],
    find: 'что стоит на прессе текстура норма' },
  { ic: '🛠', label: 'Характеристики прессов', to: '/technolog', s: 'pressSettings',
    at: 'Очередь производства › Справочники', roles: ['technolog', 'admin'],
    find: 'название пресса норма листов в час' },
  { ic: '🎨', label: 'Текстуры пресса', to: '/technolog', s: 'textures',
    at: 'Очередь производства › Справочники', roles: ['technolog', 'admin'],
    find: 'матрица гладкий молет дерево' },
  { ic: '🏷', label: 'Сорта качества', to: '/technolog', s: 'grades',
    at: 'Очередь производства › Справочники', roles: ['technolog', 'admin'],
    find: 'сорт брак список у пресса' },
  { ic: '🏭', label: 'Заводы-изготовители', to: '/technolog', s: 'makers',
    at: 'Очередь производства › Справочники', roles: ['technolog', 'admin'],
    find: 'завод изготовитель производитель плита плёнка кроношпан интерпринт поставщик' },
  { ic: '📦', label: 'Номенклатура', to: '/technolog', s: 'nom_ldsp',
    at: 'Очередь производства › Справочники', roles: ['technolog', 'admin'],
    find: 'товар лдсп дсп плёнка бумага список позиция завести' },
  { ic: '✏', label: 'Короткие имена', to: '/technolog', s: 'shortnames',
    at: 'Очередь производства › Справочники', roles: ['technolog', 'admin'],
    find: 'как называется на экране цеха сокращение' },

  // ── Менеджер: разделы (копия — до его очереди на переделку) ────────────────
  { ic: '📋', label: 'Заказы', to: '/manager', s: 'orders',
    at: 'Продажи и заказы', roles: ['manager', 'admin'],
    find: 'создать заказ клиент срок' },
  { ic: '🚚', label: 'Выписать отгрузку', to: '/manager', s: 'shipnotes',
    at: 'Продажи и заказы', roles: ['manager', 'admin'],
    find: 'распоряжение складу что выдать' },
  { ic: '📊', label: 'Отчёт по заказам', to: '/manager', s: 'feasibility',
    at: 'Продажи и заказы', roles: ['manager', 'admin'],
    find: 'хватает ли выполнимость' },
  { ic: '📦', label: 'Склад сырья', to: '/manager', s: 'stock',
    at: 'Продажи и заказы', roles: ['manager', 'admin'],
    find: 'остаток плёнка дсп сколько' },
  { ic: '👥', label: 'Контрагенты', to: '/manager', s: 'clients',
    at: 'Продажи и заказы', roles: ['manager', 'admin'],
    find: 'клиент поставщик бин инн завести' },

  // ── Отчёты и справки ───────────────────────────────────────────────────────
  { ic: '📚', label: 'Отчёты и справки', to: '/reports',
    roles: ['director', 'admin', 'sklad_gp', 'technolog', 'buhgalter'],
    find: 'справка свериться посмотреть' },
  { ic: '📑', label: 'Выпущенные листы', to: '/registry',
    roles: ['director', 'admin', 'sklad_gp', 'technolog', 'buhgalter'],
    find: 'реестр выпуска какой лист когда кем режим смена бирка' },
  { ic: '≡', label: 'Что пришло и ушло', to: '/stock-movement',
    at: 'Отчёты и справки', roles: ['director', 'admin', 'sklad_gp', 'buhgalter'],
    find: 'движение тмз приход расход сверка' },
  { ic: '⌛', label: 'Смены по дням', to: '/sessions',
    roles: ['director', 'admin', 'sklad_gp', 'technolog', 'buhgalter'],
    find: 'история пресс сдал склад принял день листы' },
  { ic: '☰', label: 'Кто что менял', to: '/audit',
    at: 'Отчёты и справки', roles: ['admin', 'director'],
    find: 'журнал действий аудит лог' },
  { ic: '⇆', label: 'Обмен с 1С', to: '/integration',
    at: 'Отчёты и справки', roles: ['admin'],
    find: 'интеграция очередь документов ключ адрес застряло' },

  // ── Своё ───────────────────────────────────────────────────────────────────
  { ic: '🔒', label: 'Сменить пароль', to: '/profile',
    roles: ['manager', 'technolog', 'quality', 'sklad_gp', 'controller',
            'director', 'admin', 'buhgalter'],
    find: 'профиль мой пароль поменять' },
];

// Экраны, доступные этой роли. Порядок сохраняем — он осмысленный: сверху
// рабочие места, ниже разделы, в конце справки.
export function screensFor(role) {
  if (!role) return [];
  // Плановик ищет «согласование» и «сменный бланк» так же, как технолог, —
  // право у него то же самое. Без этого экран открывался по ссылке, но в
  // поиске его не было, и найти его человек мог только случайно.
  const canPlan = sessionStorage.getItem('can_plan') === '1';
  return S.filter(x => x.roles.includes(role)
    || (canPlan && x.roles.includes('technolog')));
}

// Куда ведёт запись. Раздел передаём через ?s= — его ловит Layout и открывает
// нужный раздел страницы, какой бы страница ни была.
export function hrefOf(x) {
  return x.s ? `${x.to}?s=${encodeURIComponent(x.s)}` : x.to;
}

export default S;
